<div class="multi-file-uploader">
  @for (file of formArray().controls; track file; let i = $index) {
    <ng-container [formGroup]="file">
      <rp-file-uploader
        isMulti
        formControlName="file"
        [acceptTypes]="acceptTypes()"
        [acceptTypesHint]="acceptTypesHint()"
        [allowFileReplace]="allowFileReplace()"
        [maxSize]="maxSize()"
        [maxFileNameLength]="maxFileNameLength()"
        showEyeIconOnHover
        (eyeIconClicked)="eyeIconClicked.emit(i)"
        (fileRemoved)="onRemoveFile(i)"
      />
    </ng-container>
  }

  <div class="multi-file-uploader__add-file" (click)="onAddFile()">
    <rp-icon [iconName]="iconName.Add" size="l" />

    <div class="primary-text">
      {{ 'general.placeholders.addNextFile' | translate }}
    </div>
  </div>
</div>
